export const initialInputFields = [
  {
    name: 'email',
    type: 'email',
    label: 'Email*',
    placeholder: '',
  },
  {
    name: 'password',
    type: 'password',
    label: 'Password*',
    placeholder: '',
  },
];

export const twoFAInputFields = [
  {
    name: 'twoFACode',
    type: 'text',
    label: 'Two Factor Auth Code*',
    placeholder: '',
  },
];

export default initialInputFields;